"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TdWebService_1 = require("../service/TdWebService");
var useTd = function () {
    var setMemberId = function (memberId) {
        // @ts-ignore
        return TdWebService_1.TdWebService.setMemberId(memberId);
    };
    var search = function (tdId, val, url) {
        // @ts-ignore
        return TdWebService_1.TdWebService.search(tdId, val, url);
    };
    return {
        setMemberId: setMemberId,
        search: search,
    };
};
exports.default = useTd;
